import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import classnames from 'classnames';
import { TextField, InputAdornment, IconButton, FormHelperText } from '@mui/material';

import styles from './InputPassword.module.scss';
import messages from './messages';

const InputPassword = ({
  id,
  name,
  label,
  placeholder,
  handleOnChange,
  handleOnBlur,
  value,
  errorMsg,
  isValid,
  isDisabled,
  isLogin,
}: {
  id: string;
  name: string;
  label: string;
  placeholder: string;
  handleOnChange: () => void;
  handleOnBlur: () => void;
  value: string;
  errorMsg: string;
  isValid: boolean;
  isDisabled?: boolean;
  isLogin?: boolean;
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [type, setType] = useState('password');

  const { formatMessage } = useIntl();

  const toggleIsVisible = () => {
    setType(isVisible ? 'text' : 'password');
    setIsVisible(!isVisible);
  };
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const inputTestId = { 'data-testid': 'input-password-input'};
  return (
    <div className={styles[type]}>
      <TextField
        fullWidth
        id={id}
        name={name}
        label={label}
        type={type}
        placeholder={placeholder}
        error={!isValid}
        variant="filled"
        disabled={isDisabled}
        defaultValue={value}
        onChange={handleOnChange}
        onBlur={handleOnBlur}
        slotProps={{
          input: {
            inputProps: inputTestId,
            endAdornment: <InputAdornment position="end">
              <IconButton
                aria-label={
                  isVisible ? 'hide the password' : 'display the password'
                }
                onClick={toggleIsVisible}
                onMouseDown={handleMouseDownPassword}
                onMouseUp={handleMouseUpPassword}
                edge="end"
                data-testid="showHidePasswordButton"
              >
                <span
                  className={classnames(
                  isVisible ? styles.hidePasswordImg : styles.showPasswordImg,
                  )}
                />
              </IconButton>
            </InputAdornment>,
          }
        }}
      />
      {errorMsg && (
        <FormHelperText
          data-testid="errorMessage"
        >
          {errorMsg}
        </FormHelperText>
      )}
      {!isLogin && value?.length >= 0 && value?.length < 10 && !errorMsg && (
        <FormHelperText
          data-testid="errorMessage"
        >
          {formatMessage(messages.passwordLengthMessage)}
        </FormHelperText>
      )}
    </div>
  );
};
export default InputPassword;
